import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string, e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (href.startsWith('/#')) {
      const [, hash] = href.split('#');
      if (location.pathname === '/') {
        const el = document.querySelector(`#${hash}`);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate(href);
        setTimeout(() => {
          const el = document.querySelector(`#${hash}`);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      return;
    }
    navigate(href);
  };

  const navLinks = [
    { label: 'How It Works', href: '/#how-it-works' },
    { label: 'Coaching Styles', href: '/#coaching-styles' },
    { label: 'Features', href: '/#features' },
    { label: 'Knowledge', href: '/knowledge' },
    { label: 'Blog', href: '/blog' },
    { label: 'Pricing', href: '/#pricing' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-midnight/95 backdrop-blur-md py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12 flex items-center justify-between">
        <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="flex items-center gap-2">
          <img
            src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/ce990b2a1f8c24014284f37f11ea468a.jpeg"
            alt="TNT Coach AI"
            className="h-8 w-auto object-contain"
          />
        </a>

        <div className="hidden md:flex items-center gap-5 lg:gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(link.href, e)}
              className="text-silver-grey hover:text-champagne-gold transition-colors duration-300 text-sm font-medium cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="https://tnt-coach-ai.base44.app"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full gold-gradient text-midnight font-semibold text-sm hover:opacity-90 transition-opacity duration-300 whitespace-nowrap"
          >
            Try It Free
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-warm-white"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-midnight/98 backdrop-blur-md border-t border-royal-navy/30 mt-3 px-4 py-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                setMobileMenuOpen(false);
                handleNavClick(link.href, e);
              }}
              className="block py-3 text-silver-grey hover:text-champagne-gold transition-colors duration-300 text-sm font-medium cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://tnt-coach-ai.base44.app"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full gold-gradient text-midnight font-semibold text-sm mt-3 whitespace-nowrap"
            onClick={() => setMobileMenuOpen(false)}
          >
            Try It Free
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      )}
    </nav>
  );
}